import React from "react";
import { FormControl, IconButton, InputAdornment } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers";
import EventFilledIcon from "@mui/icons-material/Event";
import moment, { Moment } from "moment";
import colors from "../../../../shared/themes/colors";
import { ControllerRenderProps } from "react-hook-form";
import { dt } from "../../../../shared/themes/redesignTokens";

interface IconDatePickerProps {
  field: ControllerRenderProps<any, any>;
  name: string;
  disabled?: boolean;
  disableFuture?: boolean;
  maxDate?: Moment;
  minDate?: Moment;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const IconDatePicker = ({
  field,
  name,
  disabled = false,
  disableFuture = false,
  maxDate,
  minDate,
  isOpen,
  onOpen,
  onClose
}: IconDatePickerProps) => {
  return (
    <FormControl className="w-full">
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          {...field}
          value={field.value ? moment(field.value) : null}
          onChange={(value) => field.onChange(value?.toDate())}
          format="DD.MM.YYYY"
          disabled={disabled}
          disableFuture={disableFuture}
          maxDate={maxDate}
          minDate={minDate}
          views={['year', 'month', 'day']}
          open={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          slotProps={{
            textField: {
              name: name,
              InputProps: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        if (!disabled) {
                          onOpen();
                        }
                      }}
                      disabled={disabled}
                      sx={{
                        color: dt.blue,
                        '&:hover': {
                          backgroundColor: colors.primary.lightBlue3,
                        }
                      }}
                    >
                      <EventFilledIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }
            },
            popper: {
              sx: {
                '& .MuiPickersDay-root': {
                  '&.Mui-selected': {
                    backgroundColor: dt.blue,
                    '&:hover': {
                      backgroundColor: dt.blue,
                    }
                  }
                }
              }
            }
          }}
        />
      </LocalizationProvider>
    </FormControl>
  );
};

export default IconDatePicker;
